'use client'

import { useId, useRef } from 'react'
import { dir } from 'i18next'
import { Grid } from '@mui/material'
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'

// Types
import type { CircleProps } from '@/types/components/molecules/circle'

const CircleMolecule = (props: CircleProps) => {
	// Props
	const { lng, position, reverse } = props

	// Variables
	const lngDir = dir(lng)
	const linearGradientId = useId()
	const gridRef = useRef<HTMLDivElement>(null)
	const circleRef = useRef<SVGCircleElement>(null)
	const width = 100
	const height = 100
	const radius = 45

	// GSAP
	useGSAP(
		() => {
			gsap.timeline({
				scrollTrigger: {
					trigger: gridRef.current,
					start: 'top center',
					end: () => '+=' + gridRef.current?.offsetHeight,
					onUpdate: self => {
						gsap.set(circleRef.current, {
							attr: {
								cx: `${radius * Math.sin((self.progress / 4) * Math.PI * 2) + width / 2}`,
								cy: `${-radius * Math.cos((self.progress / 4) * Math.PI * 2) + height / 2}`,
								r: `${5 - self.progress * 3}`
							}
						})
					}
				}
			})
		},
		{ scope: gridRef }
	)

	return (
		<Grid
			ref={gridRef}
			width={{ xs: 200, md: 400 }}
			position="absolute"
			top={{ xs: reverse ? '75%' : '25%', md: reverse ? '55%' : '45%' }}
			sx={{
				...(position === 'left' ? { left: 0 } : position === 'right' ? { right: 0 } : { left: '50%' }),
				transform: position === 'right' ? 'translate(50%, -50%)' : 'translate(-50%, -50%)',
				'& svg': { transform: `scale(${position === 'right' ? (lngDir === 'rtl' ? 1 : -1) : lngDir === 'rtl' ? -1 : 1}, ${reverse ? -1 : 1})` }
			}}
		>
			<svg viewBox={`0 0 ${width} ${height}`} fill="none">
				<defs>
					<linearGradient id={linearGradientId} x1={80} y1={-15} x2={45} y2={30} gradientUnits="userSpaceOnUse">
						<stop stopColor="#4A5EA4" />
						<stop offset={1} stopColor="#070f2b" stopOpacity={0} />
					</linearGradient>
				</defs>

				<circle stroke={`url(#${linearGradientId})`} strokeWidth={1.25} cx={50} cy={50} r={45} />
				<circle ref={circleRef} fill="#ff8484" cx={width / 2} cy={width / 2 - radius} r={5} />
			</svg>
		</Grid>
	)
}

export default CircleMolecule
